<template>
<!-- 项目 - 现场预警 -->
  <div class="main-box">
      <div class="head-box">
        <el-select v-model="search.projectId" clearable filterable placeholder="所属工地" @change="dofilter">
            <el-option
            v-for="item in projects"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            </el-option>
        </el-select>
        <el-select v-model="search.type" clearable placeholder="事件类型" @change="dofilter">
            <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.name"
            :value="item.value">
            </el-option>
        </el-select>
        <el-select v-model="search.status" clearable placeholder="处理状态" @change="dofilter">
            <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <el-date-picker
            v-model="seachTime"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            @change="timefilter"
            :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div class="table-box">
          <div class="table-item" v-for="(item,index) in listData" :key="index">
              <img :src="item.imagePath" style="width:15vh;height:14vh;position: relative;" />
              <div class="table-item-con">
                  <p class="title nowrap">{{item.tsStr}}</p>
                  <p class="lable">处理状态：
                      <span style="color:#E6A23C;" v-if="item.checkStatus=='未处理'">{{item.checkStatus}}</span>
                      <span style="color:#4B7FCD;" v-else>{{item.checkStatus}}</span>
                  </p>
                  <p class="lable nowrap">发现地点：{{item.channelName}}</p>
                  <p class="lable nowrap">发现时间：{{item.happenDate}}</p>
              </div>
              <div class="table-item-con">
                  <p class="lable nowrap">处理人：{{item.handlerName||'--'}}</p>
                  <p class="lable nowrap">处理信息：{{item.handlerMsg||'--'}}</p>
              </div>
              <div class="table-item-btn flex-center">
                  <el-button type="text" style="margin-right:1vw;" @click="showInfo(item)">详情</el-button>
                  <!-- <el-button v-if="item.status=='1'" type="text" style="color:#000066;" @click="toUpdata(item)">立即处理</el-button> -->
              </div>
          </div>
          <div v-if="noData" style="width:100%;height:100%;display:flex;justify-content: center;align-content: center;align-items: center;">
              暂无数据
          </div>
      </div>
      <div style="background:#fff">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5,10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination>
      </div>
      <!-- 新增窗口(处理) -->
      <el-dialog
        title="预警处理"
        :visible.sync="handleVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="500px"
      >
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="处理人">
                <el-input v-model="form.handlerName" readonly></el-input>
            </el-form-item>
            <el-form-item label="处理信息">
                <el-input type="textarea" v-model="form.handlerMsg"></el-input>
            </el-form-item>
            <div style="width:100%;height:8vh;display:flex;justify-content: center;align-content: center;align-items: center;">
                <el-button type="primary" @click="modSubmit" round style="width:80%;">确定提交</el-button>
            </div>
        </el-form>
      </el-dialog>
      <!-- 新增窗口(详情) -->
      <el-dialog
        title="预警详情"
        :visible.sync="infoVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class="scene-dialog"
        class="add-form"
        width="60%"
        style="min-width:900px;"
      >
        <div class="head1">
            <img :src="info.imagePath" style="width:50%;height:100%;position: relative;" />
            <div style="width:50%;height:100%;position: relative;padding-left:2vh;">
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警类型：<span style="color:#993300;">{{info.name}}</span></p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警内容：{{info.tsStr}}</p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">发现地点：{{info.channelName}}</p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警时间：{{info.happenDate}}</p>
            </div>
        </div>
        <h1 style="width:100%;padding:1vh;font-size:1.8vh;">处理信息</h1>
        <p style="padding:1vh 0 3vh 10vh;">处理状态：<span style="color:#4B7FCD;" v-if="info.status=='0'">已处理</span><span style="color:#FF6633;" v-else>待处理</span></p>
        <div class="con" style="padding-left:10vh;">
            <el-timeline>
                <el-timeline-item timestamp="预警" placement="top" color="#108ee9" style="color:#000;" >
                    <div style="background:rgba(184, 221, 248, 0.2);padding:2vh;">
                        <p>{{info.tsStr}}</p>
                    </div>
                    <p style="position: absolute;top: -25px;left: -120px;width: 5vw;color: #999;">{{info.happenDate}}</p>
                </el-timeline-item>
                <el-timeline-item timestamp="处理完成" placement="top" v-if="info.status=='0'" color="#108ee9" style="color:#000;" >
                    <div style="background:rgba(184, 221, 248, 0.2);padding:2vh;">
                        <h4>处理人：{{info.handlerName}}</h4>
                        <p style="margin-top:1vh;">{{info.handlerMsg}}</p>
                    </div>
                    <p style="position: absolute;top: -2.5vh;left: -12vh;width: 10vh;color: #999;">{{info.handlerDate}}</p>
                </el-timeline-item>
                <el-timeline-item timestamp="待处理" placement="top" v-else color="#b8ddf8">
                    
                </el-timeline-item>
            </el-timeline>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../untils/port';
import util from '../../untils/util';
export default {
    data(){
        return{
            search:{
                type:'',
                status:'',
                projectId:''
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            types:[],
            statusList:[{label:'已处理',value:'0'},{label:'未处理',value:'1'}],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            seachTime:'',
            listData:[],//列表
            noData:false,//是否有数据
            dialogTitle:'预警详情',//
            handleVisible:false,
            form:{   //预警处理
                handlerName:'',
                handlerId:'',
                status:'0',
                handlerMsg:''
            },
            infoVisible:false,//详情弹出框
            info:{  //详情信息

            },
            projects:[],
        }
    },
    mounted(){
        this.seachTime = util.myTime.getCurWeek()
        this.groupId = util.session.get('groupId')
        this.getTypeList()
        
        this.getProjects()
    },
    methods:{
        //获取事件类型
        getTypeList(){
            var that = this
            myHttp.getTopicValueList().then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.aiEquipCameraTopics||[];
                    that.types = list;
                }else{
                    that.$message.error(resp.data.msg);
                }
            },function(){});
        },
        //条件过滤
        dofilter(){
            this.getData()
        },
        //时间过滤
        timefilter(){
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        getData(){
            var that = this
            myHttp.selectAiWarningPage({
                projectId:this.search.projectId,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                status:this.search.status,
                type:this.search.type,
                startTime:this.seachTime[0],
                endTime:this.seachTime[1],
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.aiWarningList.list||[]
                    that.listData = list
                    that.totalItems = resp.data.data.aiWarningList.total||0
                    if(list.length==0){
                        that.noData = true
                    }else{
                        that.noData = false
                    }
                }else{
                    that.noData = true
                }
            })
        },

        //处理弹出框
        toUpdata(row){
            this.form.id = row.warningId
            this.form.handlerName = util.session.get('user').name
            this.form.handlerId = util.session.get('user').id
            this.handleVisible = true
        },
        //处理
        modSubmit(){
            var that = this
            myHttp.updateAiEquip(this.form).then(function(resp){
                if(resp.data.code=='200'){
                    that.handleVisible = false
                    that.getData()
                    that.$message.success('处理成功');
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        //展示内容
        showInfo(row){
            //var that = this
            this.info = row
            this.infoVisible = true
        },
        //获取数据
        getProjects(){
            var that = this
            myHttp.getProjectPageListByEntIdAndJoinType({
                entId : this.groupId,
                pageNum:1,
                pageSize:1000
            }).then(function(resp){
                var list = resp.data.data.pageInfo.list || []
                that.projects = list
                if(list.length>0){
                    that.search.projectId = list[0].id
                }
                that.getData()
            })
        },
    }
}
</script>

<style scoped>
    .main-box{
        width: 100%;
        height: 100%;
        position: relative;
        /* padding: 1vw; */
        background: #fff;
    }
    .head-box{
        width: 100%;
        height: 6vh;
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-content: center;
        align-items: center;
        background: #f2f2f2;
    }
    .head-box *{
        margin-right: 1vw;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 14vh );
        position: relative;
        padding: 1vh 0;
        overflow: auto;
    }
    .table-item{
        width: 100%;
        height: 16vh;
        padding: 2vh 2vh 0;
        position: relative;
        border-bottom: 1px solid #F2F2F2;
        display: flex;
    }
    .table-item-con{
        width: calc( 50% - 17.5vh );
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding-left: 4vw;
    }
    .table-item-btn{
        width: 20vh;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .table-item-con .title{
        width: 100%;
        height: 4vh;
        color: #993300;
        font-size: 1vw;
        position: relative;
        line-height: 4vh;
    }
    .table-item-con .lable{
        width: 100%;
        height: 3vh;
        position: relative;
    }
    .table-item-con p{
        text-align: left;
    }
    .flex-center{
        display: flex;
        justify-content: center;
        justify-items: center;
    }

    /* .scene-dialog{
        width:100
    } */
    .scene-dialog .head1{
        width: 100%;
        height: 27vh;
        padding: 0 1vh;
        margin-bottom: 3vh;
        position: relative;
        display: flex;
    }
</style>
<style>
    @import '../../assets/css/common.css'
</style>